import React from 'react';
import PropTypes from 'prop-types';
import BaseDropdownV2 from '../BaseDropdownV2';
import { getAccountManagers } from 'services/salesperson-kpi/newBusAnalysis';

const SpAccountManagerDropdown = ({
  closeMenuOnSelect = true,
  fieldName = { fieldName },
  isMulti = false,
  placeholder = 'Manager',
  handleChange,
  selectedOptions,
  styles,
  required,
  showError = false,
  hasError
}) => {
  return (
    <>
      <BaseDropdownV2
        fieldName={fieldName}
        closeMenuOnSelect={closeMenuOnSelect}
        isMulti={isMulti}
        placeholder={placeholder}
        handleChange={handleChange}
        getSource={getAccountManagers}
        mapToOption={res => {
          return res?.data
            ?.sort((a, b) => a.name.localeCompare(b.name))
            .map(i => {
              return { ...i, value: i.id, label: i.name };
            });
        }}
        value={selectedOptions}
        styles={styles}
        required={required}
        showError={showError}
        hasError={hasError}
      />
    </>
  );
};

SpAccountManagerDropdown.propTypes = {
  collapseValues: PropTypes.bool,
  maxToShow: PropTypes.number,
  isDisabled: PropTypes.bool,
  required: PropTypes.bool,
  title: PropTypes.string,
  closeMenuOnSelect: PropTypes.func,
  isMulti: PropTypes.bool,
  param: PropTypes.object,
  placeholder: PropTypes.string,
  handleChange: PropTypes.func,
  hasError: PropTypes.func,
  fieldName: PropTypes.string,
  selectedOptions: PropTypes.object,
  styles: PropTypes.object,
  showError: PropTypes.bool,
};

export default SpAccountManagerDropdown;
